import { render, staticRenderFns } from "./SurveyYear.vue?vue&type=template&id=134566eb&scoped=true&"
import script from "./SurveyYear.vue?vue&type=script&lang=js&"
export * from "./SurveyYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134566eb",
  null
  
)

export default component.exports